/**
 * HTTPS fallback landing after custom-scheme redirect to Studio/desktop.
 * Does not read or store tokens — query params are for the desktop app only.
 */
export default function OauthDesktopReturnPage() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--color-background, #f3f3f6)",
        color: "var(--color-text-secondary, #707070)",
        fontFamily: '"SF Pro Display", system-ui, sans-serif',
        textAlign: "center",
        padding: 24,
      }}
    >
      <div>
        <h1
          style={{
            color: "var(--color-text, #08073b)",
            fontSize: 22,
            margin: "0 0 8px",
          }}
        >
          Returning to Studio
        </h1>
        <p style={{ margin: 0 }}>
          You can close this window if the app does not open automatically.
        </p>
      </div>
    </main>
  );
}
